import type {ReasoningMessagePartComponent} from '@assistant-ui/react';
import Markdown from '@wandb/weave/common/components/Markdown';
import {MarkdownContainer} from '@wandb/weave/components/PagePanelComponents/Home/Browse3/pages/ChatView/MarkdownContainer';
import React, {memo} from 'react';

import {WBAgentDisclosure} from './WBAgentDisclosure';

const ReasoningImpl: ReasoningMessagePartComponent = ({text}) => {
  return (
    <WBAgentDisclosure icon="reasoning" label="Reasoning">
      <div className="text-moon-500">
        <MarkdownContainer>
          <Markdown content={text} shouldEjectFromTailwind={false} />
        </MarkdownContainer>
      </div>
    </WBAgentDisclosure>
  );
};

export const WBAgentReasoning = memo(
  ReasoningImpl
) as ReasoningMessagePartComponent;
WBAgentReasoning.displayName = 'WBAgentReasoning';
